var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customLayout" },
    [
      !_vm.disabled && !_vm.isEmpty(_vm.info)
        ? _c("div", { staticClass: "pageTitle" }, [
            _c(
              "span",
              { staticClass: "left" },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.info.category_id ? "功能菜单装修" : "商城首页装修"
                    ) +
                    " - "
                ),
                [
                  "plat_custom",
                  "service_custom",
                  "plat_service_custom",
                  "custom",
                ].includes(_vm.info.module)
                  ? [_vm._v(" " + _vm._s(_vm.info.customer_name) + " ")]
                  : [
                      _vm._v(
                        " " +
                          _vm._s(_vm.info.short_name || _vm.info.company_name) +
                          " " +
                          _vm._s(_vm.info.module === "admin" ? "(渠道)" : "") +
                          " "
                      ),
                    ],
              ],
              2
            ),
          ])
        : _vm._e(),
      _c(
        "el-card",
        { attrs: { shadow: "never" } },
        [
          !_vm.disabled
            ? _c(
                "el-tabs",
                {
                  staticClass: "myTab",
                  attrs: { type: "card" },
                  model: {
                    value: _vm.activeTab,
                    callback: function ($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab",
                  },
                },
                _vm._l(_vm.tabList, function (tab) {
                  return _c("el-tab-pane", {
                    key: tab.group_key,
                    attrs: { name: tab.group_key, label: tab.name },
                  })
                }),
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "log" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "medium", plain: "" },
                  on: { click: _vm.refreshMenus },
                },
                [_vm._v(" 菜单刷新 ")]
              ),
              _vm.$hasBtnRoles(
                {
                  admin: "/decoration/decoration/get-decoration-log",
                  custom: "/decoration/decoration/get-customer-decoration-log",
                  plat_custom: "/plat/decoration/get-customer-decoration-log",
                  channel: "/decoration/decoration/get-shop-decoration-log",
                }[_vm.info.module]
              )
                ? _c("span", { on: { click: _vm.getLogData } }, [
                    _c("i", { staticClass: "el-icon el-icon-s-order" }),
                    _vm._v(" 操作日志 "),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm.disabled || _vm.tabList.length
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.releaseLoading,
                      expression: "releaseLoading",
                    },
                  ],
                  staticClass: "center",
                },
                [
                  _vm.activeTab === "basic"
                    ? [
                        _c("bg-color", {
                          attrs: {
                            info: _vm.info,
                            style_id: _vm.style_id,
                            source: _vm.info.category_id ? "category" : "home",
                            childrenMenuList: _vm.childrenMenuList,
                            customParams: {
                              template_config_id: _vm.template_config_id,
                            },
                          },
                          on: {
                            onSave: _vm.saveBasic,
                            updateBorder: _vm.updateBorder,
                          },
                        }),
                      ]
                    : _vm.activeTab === "notice"
                    ? [_c("notice-message", { attrs: { info: _vm.info } })]
                    : [
                        !_vm.disabled
                          ? _c("div", { class: ["leftPanel", _vm.activeTab] }, [
                              _c(
                                "div",
                                { staticClass: "panelContent" },
                                [
                                  _vm.activeTab === "super_widget"
                                    ? _c(
                                        "div",
                                        { staticClass: "panelForm" },
                                        [
                                          _c(
                                            "el-input",
                                            {
                                              attrs: {
                                                placeholder:
                                                  "请输入要搜索的组件名称",
                                                clearable: "",
                                              },
                                              model: {
                                                value: _vm.panelForm.name,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.panelForm,
                                                    "name",
                                                    $$v
                                                  )
                                                },
                                                expression: "panelForm.name",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: { slot: "append" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.changePanelPage(
                                                        1
                                                      )
                                                    },
                                                  },
                                                  slot: "append",
                                                },
                                                [_vm._v("搜索")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.activeLeftData.value.length
                                    ? [
                                        _c(
                                          "draggable",
                                          {
                                            staticClass: "draggable",
                                            attrs: {
                                              animation: "500",
                                              "force-fallback": true,
                                              group: {
                                                name: "panelMove",
                                                pull: "clone",
                                                put: false,
                                              },
                                              sort: false,
                                              filter:
                                                "" +
                                                _vm.leftFilterArr
                                                  .concat(_vm.leftFilterDomList)
                                                  .map(function (key) {
                                                    return "." + key
                                                  })
                                                  .toString(),
                                              move: _vm.onMovePanel,
                                            },
                                            on: { end: _vm.moveEndPanel },
                                            model: {
                                              value: _vm.activeLeftData.value,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.activeLeftData,
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "activeLeftData.value",
                                            },
                                          },
                                          _vm._l(
                                            _vm.activeLeftData.value,
                                            function (item, index) {
                                              return _c("mall", {
                                                key: item.key + "_" + index,
                                                class: ["model", item.key],
                                                attrs: { item: item },
                                                on: { _addPanel: _vm.addPanel },
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.addPanel(item)
                                                  },
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ]
                                    : _c("div", { staticClass: "noData" }, [
                                        _vm._v("暂无数据"),
                                      ]),
                                ],
                                2
                              ),
                              _vm.activeTab === "super_widget"
                                ? _c(
                                    "div",
                                    { staticClass: "pagination" },
                                    [
                                      _c("el-pagination", {
                                        attrs: {
                                          background: "",
                                          layout:
                                            "total, prev, pager, next, jumper",
                                          "current-page": _vm.panelForm.page,
                                          "page-size": _vm.panelForm.page_size,
                                          total: _vm.panelCount,
                                        },
                                        on: {
                                          "current-change": _vm.changePanelPage,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "contentWrap" },
                          [
                            _c(
                              "div",
                              { staticClass: "contentTitle" },
                              [
                                _vm.info.menu
                                  ? [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.info.temp_name
                                              ? "当前模板 - " +
                                                  _vm.getTempName(
                                                    _vm.info.temp_name
                                                  )
                                              : "「" +
                                                  _vm.info.menu +
                                                  "」效果预览"
                                          ) +
                                          " "
                                      ),
                                      _vm.info.temp_id
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "changeTemp",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.getTemplate({
                                                    scroll_cb: true,
                                                  })
                                                },
                                              },
                                            },
                                            [_vm._v("切换模板")]
                                          )
                                        : _vm._e(),
                                    ]
                                  : [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.info.temp_name
                                              ? "当前模板 - " +
                                                  _vm.getTempName(
                                                    _vm.info.temp_name
                                                  )
                                              : "商城首页效果预览"
                                          ) +
                                          " "
                                      ),
                                      _vm.info.temp_id
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "changeTemp",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.getTemplate({
                                                    scroll_cb: true,
                                                  })
                                                },
                                              },
                                            },
                                            [_vm._v("切换模板")]
                                          )
                                        : _vm._e(),
                                    ],
                              ],
                              2
                            ),
                            _c(
                              "div",
                              { ref: "content", staticClass: "content" },
                              [
                                _c(
                                  "div",
                                  {
                                    ref: "phone",
                                    staticClass: "phone",
                                    attrs: { id: "phone" },
                                  },
                                  [
                                    _c(
                                      "draggable",
                                      {
                                        class: [
                                          "clearfix",
                                          _vm.background_config
                                            .background_type === 1 && "bg-img",
                                        ],
                                        style: _vm.dynamicStyle,
                                        attrs: {
                                          animation: "500",
                                          group: "panelMove",
                                          id: "draggableCenter",
                                          "force-fallback": true,
                                          move: _vm.onMoveCenter,
                                        },
                                        on: {
                                          start: _vm.handleStartRemove,
                                          end: _vm.handleEndRemove,
                                        },
                                        model: {
                                          value: _vm.layoutList,
                                          callback: function ($$v) {
                                            _vm.layoutList = $$v
                                          },
                                          expression: "layoutList",
                                        },
                                      },
                                      [
                                        _vm._l(
                                          _vm.layoutList,
                                          function (item, index) {
                                            return [
                                              !["bottom"].includes(item.key)
                                                ? _c(
                                                    "div",
                                                    {
                                                      key: item.uid,
                                                      class: [
                                                        "plate-wrap",
                                                        item.key,
                                                        item.uid ===
                                                          _vm.configData.uid &&
                                                          "current",
                                                        item.error && "error",
                                                      ],
                                                      staticStyle: {
                                                        "border-width": "1px",
                                                      },
                                                      style:
                                                        _vm.getLayoutStyle(
                                                          item
                                                        ),
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.plateHandle(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        _vm.isEmpty(
                                                          item.config
                                                        ) &&
                                                          !_vm.noConfigList.includes(
                                                            item.key
                                                          )
                                                          ? "empty"
                                                          : item.key_pointer
                                                          ? item.key_pointer
                                                          : item.key,
                                                        {
                                                          tag: "component",
                                                          class:
                                                            "empty_" + item.key,
                                                          attrs: {
                                                            value: item,
                                                            nextValue:
                                                              _vm.layoutList[
                                                                index + 1
                                                              ] || {},
                                                            styleId:
                                                              _vm.style_id,
                                                          },
                                                          on: {
                                                            change: function (
                                                              res
                                                            ) {
                                                              return _vm.showOneIcon(
                                                                res,
                                                                item
                                                              )
                                                            },
                                                          },
                                                        }
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon el-icon-close",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.removeLayout(
                                                              item,
                                                              index
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ]
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                    !_vm.isEmpty(_vm.bottomData)
                                      ? _c("bottom", {
                                          ref: "bottomRef",
                                          class: [
                                            "plate-wrap",
                                            _vm.bottomData.key,
                                            _vm.bottomData.uid ===
                                              _vm.configData.uid && "current",
                                            _vm.bottomData.error && "error",
                                          ],
                                          staticStyle: {
                                            "border-width": "1px",
                                          },
                                          attrs: {
                                            value: _vm.bottomData,
                                            info: _vm.info,
                                          },
                                          on: {
                                            removeBottom: function ($event) {
                                              return _vm.removeLayout(
                                                _vm.bottomData,
                                                0,
                                                "bottom"
                                              )
                                            },
                                          },
                                          nativeOn: {
                                            click: function ($event) {
                                              return _vm.plateHandle(
                                                _vm.bottomData
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                    _vm.allLayoutList.length < 1
                                      ? _c(
                                          "div",
                                          { staticClass: "add-plate" },
                                          [
                                            _vm.noPlate
                                              ? _c("div", [
                                                  _vm._v(
                                                    "暂无板块，请去板块管理添加板块"
                                                  ),
                                                ])
                                              : [
                                                  _c(
                                                    "span",
                                                    { staticClass: "icon-add" },
                                                    [_vm._v("+")]
                                                  ),
                                                  _c("span", [
                                                    _vm._v(
                                                      "请从左侧添加功能板块"
                                                    ),
                                                  ]),
                                                ],
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            !_vm.disabled
                              ? [
                                  _c("div", { staticClass: "tips" }, [
                                    _vm._v("将组件拖出预览区即可删除"),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "contentBtns" },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            loading: _vm.releaseLoading,
                                          },
                                          on: { click: _vm.release },
                                        },
                                        [_vm._v("发布")]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "warning" },
                                          on: { click: _vm.createTemplate },
                                        },
                                        [_vm._v("生成模板")]
                                      ),
                                      _vm.canSaveThumb
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "success",
                                                loading: _vm.thumbLoading,
                                              },
                                              on: { click: _vm.saveThumb },
                                            },
                                            [_vm._v("保存图片")]
                                          )
                                        : _vm._e(),
                                      _vm.info.module === "custom" &&
                                      _vm.$hasBtnRoles(
                                        "/customer/customer-account-new/get-url"
                                      )
                                        ? _c(
                                            "el-button",
                                            {
                                              on: { click: _vm.previewSetting },
                                            },
                                            [_vm._v("装修预览")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                        _c(
                          "div",
                          {
                            class: [
                              "config",
                              _vm.isEmpty(_vm.configData) && "noData",
                            ],
                          },
                          [
                            !_vm.isEmpty(_vm.configData)
                              ? [
                                  _c("div", { staticClass: "header" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.configData.widget) + "配置"
                                      ),
                                    ]),
                                    _c("i", {
                                      staticClass: "el-icon el-icon-close",
                                      on: { click: _vm.closeConfigPanel },
                                    }),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "configContent" },
                                    [
                                      _c(
                                        (_vm.configData.key_pointer ||
                                          _vm.configData.key) + "_config",
                                        {
                                          key: _vm.configData.uid,
                                          ref: "config",
                                          tag: "component",
                                          staticClass: "configCom",
                                          attrs: {
                                            source: _vm.info.category_id
                                              ? "category"
                                              : "home",
                                            styleId: _vm.style_id,
                                            menuList: _vm.menuList,
                                            childrenMenuList:
                                              _vm.childrenMenuList,
                                            customerModuleList:
                                              _vm.customerModuleList,
                                            eBookCategoryList:
                                              _vm.eBookCategoryList,
                                            aBookCategoryList:
                                              _vm.aBookCategoryList,
                                            customerPackageList:
                                              _vm.customerPackageList,
                                            systemMenus: _vm.systemMenus,
                                            tabListFlat: _vm.tabListFlat,
                                            info: _vm.info,
                                            categoryMode: true,
                                            disabled: _vm.disabled,
                                            uploadInfo: _vm.uploadInfo,
                                          },
                                          on: {
                                            closeConfigPanel:
                                              _vm.closeConfigPanel,
                                            saveConfig: _vm.saveConfig,
                                          },
                                          model: {
                                            value: _vm.configData,
                                            callback: function ($$v) {
                                              _vm.configData = $$v
                                            },
                                            expression: "configData",
                                          },
                                        }
                                      ),
                                      !_vm.disabled
                                        ? _c(
                                            "div",
                                            { staticClass: "configBtns" },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    loading: _vm.configLoading,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.saveConfig()
                                                    },
                                                  },
                                                },
                                                [_vm._v("保存")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ],
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "myDialog",
          attrs: { title: "生成模板", width: "700px", visible: _vm.show },
          on: {
            "update:visible": function ($event) {
              _vm.show = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "dialogForm",
              staticClass: "home__form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-suffix": "：",
                "label-width": "100px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "name", label: "模板名称" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入" },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "template_type", label: "模板级别" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.template_type,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "template_type", $$v)
                        },
                        expression: "form.template_type",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("渠道级"),
                      ]),
                      _vm.info.module === "admin"
                        ? _c("el-radio", { attrs: { label: "2" } }, [
                            _vm._v("平台级"),
                          ])
                        : _vm._e(),
                      [
                        "plat_custom",
                        "service_custom",
                        "plat_service_custom",
                        "custom",
                        "channel",
                      ].includes(_vm.info.module)
                        ? _c("el-radio", { attrs: { label: "3" } }, [
                            _vm._v("客户级"),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.info.module === "admin" && _vm.form.template_type === "1"
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "channel_id", label: "选择渠道" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { filterable: "", placeholder: "请选择" },
                          model: {
                            value: _vm.form.channel_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "channel_id", $$v)
                            },
                            expression: "form.channel_id",
                          },
                        },
                        _vm._l(_vm.channelList, function (value, key) {
                          return _c("el-option", {
                            key: key,
                            attrs: { value: key, label: value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              [
                "plat_custom",
                "service_custom",
                "plat_service_custom",
                "custom",
                "channel",
              ].includes(_vm.info.module) && _vm.form.template_type === "3"
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "customer_id", label: "选择客户" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            remote: "",
                            "remote-method": _vm.remoteMethod,
                            placeholder: "请输入客户名称",
                          },
                          model: {
                            value: _vm.form.customer_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "customer_id", $$v)
                            },
                            expression: "form.customer_id",
                          },
                        },
                        _vm._l(_vm.companyList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.company_name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.show = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.dialogLoading },
                  on: { click: _vm.onSubmit },
                },
                [_vm._v("完成")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "tempDialog",
          attrs: {
            visible: _vm.templateShow,
            top: "20px",
            title: "切换商城首页模板",
            "lock-scroll": "",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.templateShow = $event
            },
          },
        },
        [
          _c(
            "div",
            { ref: "tempContent", staticClass: "content" },
            [
              _c("template-list", {
                attrs: {
                  curTips: _vm.info.customer_id
                    ? "若当前客户未装修过，当前配置为继承的渠道配置"
                    : "",
                  list: _vm.templateList,
                  showCurrent: false,
                  currentThumb: "current_thumb",
                  pages: _vm.pages,
                },
                on: { onSelect: _vm.selectTemp, loadMore: _vm.getTemplate },
              }),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  staticStyle: { width: "90px", "line-height": "1.2" },
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.templateShow = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.showBanner, title: "电影banner图设置" },
          on: {
            "update:visible": function ($event) {
              _vm.showBanner = $event
            },
          },
        },
        [
          _vm._l(_vm.bannerParams.data, function (item, index) {
            return _c(
              "div",
              { key: index, staticClass: "movie-banner upload" },
              [
                _c(
                  "div",
                  {
                    staticClass: "upload-item-wrap",
                    staticStyle: { display: "flex" },
                  },
                  [
                    _c("upload-files", {
                      ref: "uploadBanner",
                      refInFor: true,
                      attrs: {
                        "link-url": _vm.linkUrl,
                        tempurl: item.thumb,
                        uploadInfo: _vm.uploadInfo,
                      },
                      on: {
                        emitUploadFile: function (res) {
                          return _vm.emitUploadFile(res, item)
                        },
                      },
                    }),
                    _c(
                      "div",
                      { staticStyle: { "margin-left": "10px" } },
                      [
                        _vm.bannerParams.data.length > 1
                          ? _c(
                              "el-button",
                              {
                                staticClass: "el-icon-delete add-icon",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDelUpload(index)
                                  },
                                },
                              },
                              [_vm._v(" 删除图片 ")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            )
          }),
          _c(
            "div",
            { staticStyle: { margin: "20px", "text-align": "center" } },
            [
              _c(
                "el-button",
                {
                  staticClass: "el-icon-plus add-upload",
                  attrs: { type: "primary" },
                  on: { click: _vm.addUpload },
                },
                [_vm._v(" 新增轮播图")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _c(
                "el-button",
                {
                  staticStyle: { width: "200px" },
                  attrs: { type: "success" },
                  on: { click: _vm.handleBanner },
                },
                [_vm._v(" 完成")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            top: "20px",
            width: "70%",
            title: "查看操作日志",
            "lock-scroll": "",
            visible: _vm.dialogShow,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogShow = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _c(
            "el-form",
            { ref: "dialogForm", attrs: { model: _vm.dialogForm, inline: "" } },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "operate_time", label: "操作时间" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "value-format": "yyyy-MM-dd",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                    },
                    model: {
                      value: _vm.dialogForm.operate_time,
                      callback: function ($$v) {
                        _vm.$set(_vm.dialogForm, "operate_time", $$v)
                      },
                      expression: "dialogForm.operate_time",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "operator_id", label: "操作人" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.dialogForm.operator_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.dialogForm, "operator_id", $$v)
                        },
                        expression: "dialogForm.operator_id",
                      },
                    },
                    _vm._l(_vm.sellUserList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.getLogData } },
                [_vm._v("搜索")]
              ),
              _c("el-button", { on: { click: _vm.resetLogForm } }, [
                _vm._v("重置"),
              ]),
            ],
            1
          ),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.logList,
                "header-cell-style": {
                  background: "#f1f1f1",
                  color: "#333333",
                },
                height: "60vh",
              },
            },
            [
              _c("el-table-column", {
                attrs: { width: "80px", prop: "id", label: "编号" },
              }),
              _c("el-table-column", {
                attrs: { prop: "note", "min-width": "300px", label: "内容" },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "170px",
                  prop: "create_time",
                  label: "操作时间",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "150px",
                  prop: "operator_name",
                  label: "操作人",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "margin-top": "10px", "text-align": "right" } },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout:
                    _vm.activeTab === "notice"
                      ? "total, sizes, prev, pager, next, jumper"
                      : "total, prev, pager, next, jumper",
                  "page-sizes": [10, 20, 50, 100],
                  "current-page": _vm.dialogForm.page,
                  "page-size": _vm.dialogForm.page_size,
                  total: _vm.logTotalCount,
                },
                on: {
                  "size-change": _vm.handleLogSizeChange,
                  "current-change": _vm.getLogData,
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogShow = false
                    },
                  },
                },
                [_vm._v(" 关闭 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("linkDrawer", {
        attrs: {
          title: "装修预览",
          size: "88%",
          drawerVisible: _vm.showDrawer,
          drawerSetting: _vm.trendParams,
          origin: "layout",
        },
        on: { close: _vm.onCloseLinkDrawer },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }